import {
  PushAdminStats,
  PushAdminUsersFilters,
  PushAdminUsersResponse,
  PushDevice,
  PushMessageListFilters,
  PushMessageListResponse,
  SendPushMessageDto,
  SendPushMessageResponse,
  SubscribePushDto,
  UnsubscribePushDto,
  VapidPublicKeyResponse,
} from "@myapp/contract";
import apiClient from "../../../shared/config/axios";

export const notificationApi = {
  getVapidPublicKey: () =>
    apiClient.get<VapidPublicKeyResponse>("/notifications/push/vapid-public-key"),

  subscribe: (dto: SubscribePushDto) =>
    apiClient.post<PushDevice>("/notifications/push/subscriptions", dto),

  unsubscribe: (dto: UnsubscribePushDto) =>
    apiClient.post<void>("/notifications/push/unsubscribe", dto),

  listAdminUsers: (params: PushAdminUsersFilters) =>
    apiClient.get<PushAdminUsersResponse>("/notifications/push/admin/users", { params }),

  getAdminStats: () =>
    apiClient.get<PushAdminStats>("/notifications/push/admin/stats"),

  listMessages: (params: PushMessageListFilters) =>
    apiClient.get<PushMessageListResponse>("/notifications/push/admin/messages", { params }),

  sendMessage: (dto: SendPushMessageDto) =>
    apiClient.post<SendPushMessageResponse>("/notifications/push/admin/messages", dto),

  revokeDevice: (id: number) =>
    apiClient.delete<void>(`/notifications/push/admin/devices/${id}`),
};
